import { Loader2 } from 'lucide-react'

/** Shown while lazy-loaded route chunks download. */
export function PageLoader() {
    return (
        <div
            className="flex min-h-[50vh] items-center justify-center"
            role="status"
            aria-live="polite"
            aria-label="Loading page"
        >
            <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
        </div>
    )
}
